/* eslint-disable no-console */
import { EntrGroups } from "@/auth/entra-groups";
import { MappedErrorMessage } from "@/models/forms/errorMessageMapper";

/**
 * Handles error messages based on error codes.
 */
export const errorMessageHandler = (error: string, errorBoxMessages: MappedErrorMessage[]): string => {
  const errorMessages: Record<string, string | undefined> = {
    invalidCredentials: errorBoxMessages?.find((msg) => msg.name === "invalidCredentials")?.message,
    invalidToken: errorBoxMessages?.find((msg) => msg.name === "invalidToken")?.message,
    unexpectedError: errorBoxMessages?.find((msg) => msg.name === "unexpectedError")?.message
  };

  if (!errorBoxMessages || errorBoxMessages.length === 0) {
    return "An unexpected error occurred.";
  }
  // Return the corresponding message if it exists
  if (errorMessages[error]) {
    return errorMessages[error]!;
  }
  // If no corresponding message exists, return the error string itself
  if (error) {
    return error;
  }
  // If no error is passed, return the "unexpected error" message
  return errorMessages.unexpectedError || "An unexpected error occurred";
};
/**
 * Handles group-based redirection.
 */


export const isAgent = (groupHashTable: Map<string, boolean>): boolean => {
  const result =
    EntrGroups.Agent.some(id => groupHashTable.has(id));
  // eslint-disable-next-line no-console
  console.log(result, "isAgent");
  return result;
};
